export const historyAndIntakeSectionConfiguration: any[] = [
    {
        "sectionKey": "History",
        "subSectionKey": "demographicInformation",
        "subSectionTitle": "Demographic Information",
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "headers": [
            {
                "label": "Occupation",
                "display": "OCCUPATION",
                "mandatory": false,
                "colSize": "small"
            },
            {
                "label": "Sexual Orientation",
                "display": "SEXUAL ORIENTATION",
                "mandatory": false,
                "colSize": "medium"
            },
            {
                "label": "Marital Status",
                "display": "MARITAL STATUS",
                "mandatory": false
            }
        ],
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "demographicInfo",
                "class": "",
                "answerList": [
                    {
                        "type": "TYPEAHEAD",
                        "key": "occupation",
                        "displayKey": "occupationDisplay",
                        "placeholder": "Enter",
                        "textSize": "small",
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "occupations"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "header": "Complaints",
                        "inline": false,
                        "enableSearchIcon": true,
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Demographic Information",
                                        "field": "Occupation",
                                        "inputType": "Text"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "type": "TYPEAHEAD",
                        "key": "sexualOrientation",
                        "displayKey": "sexualOrientationDisplay",
                        "placeholder": "Other",
                        "textSize": "medium",
                        "suggestions": ["Straight", "Gay", "Lesbian"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "sexual_orientation"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Demographic Information",
                                        "field": "Sexual Orientation",
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "type": "BOOLEAN_TOGGLE",
                        "key": "maritalStatus",
                        "textSize": "",
                        "values": [
                            { "internalValue": "SINGLE", "displayValue": "Single" },
                            { "internalValue": "MARRIED", "displayValue": "Married" },
                            { "internalValue": "DIVORCED", "displayValue": "Divorced" }
                        ],
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Demographic Information",
                                        "field": "Marital Status",
                                        "inputType": "Tags"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "emergencyContact",
        "subSectionTitle": "Emergency Contact",
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "headers": [
            {
                "label": "Name",
                "display": "NAME",
                "mandatory": false,
                "colSize": "small"
            },
            {
                "label": "Relation",
                "display": "RELATION",
                "mandatory": false,
                "colSize": "medium"
            },
            {
                "label": "Number",
                "display": "NUMBER",
                "mandatory": false
            }
        ],
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "emergencyContactList",
                "class": " ",
                "answerList": [
                    {
                        "type": "TEMPLATED_LIST",
                        "templatedListConfiguration": {
                            "preventRowAddition": false,
                            "hideRemoveBtn": false,
                            "autoAddNewRow": false
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Emergency Contact",
                                    }
                                }
                            ]
                        },
                        "fields": [
                            {
                                "type": "TEXT_FIELD",
                                "key": "name",
                                "placeholder": "Enter",
                                "textSize": "small"
                            },
                            {
                                "type": "TYPEAHEAD",
                                "key": "relation",
                                "placeholder": "Enter",
                                "textSize": "medium",
                                "suggestions": ["Friend", "Sibling", "Spouse"],
                                "typeAheadConfiguration": {
                                    "source": "MAVERICK",
                                    "url": "/maverick/care/static_generic_catalogue",
                                    "appendQueryString": true,
                                    "otherKeysMapping": {
                                        "result-size": 5
                                    },
                                    "additionalParams": {
                                        "catalogueName": "emergency_contact_relation"
                                    },
                                    "additionalInfoLabelKeys": [],
                                    "valueKey": "internalName",
                                    "labelKey": "displayName",
                                    "internalKey": "internalName",
                                    "inputParam": "q",
                                    "allowAddItem": true,
                                    "addItemToTypeahead": {
                                        "displayText": "Click to add new"
                                    },
                                    "resultMapper": {
                                        "internalValue": "internalValue",
                                        "displayValue": "displayValue"
                                    }
                                }
                            },
                            {
                                "type": "TEXT_FIELD",
                                "key": "number",
                                "placeholder": "Enter",
                                "textSize": "small"
                            },
                        ]
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "presentingProblems",
        "subSectionTitle": "Presenting Problems",
        "subHeaderTags": ["When did the concerns start?", "Any symptoms?"],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "problem",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["Anxiety", "Relationship Issues", "Sleep Issues", "Feeling Low", "Overthinking"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "presenting_problems"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Presenting Problems"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "familyHistory",
        "subSectionTitle": "Family History",
        "subHeaderTags": ["Currently living with?", "Quality of relationships?", "Family stressors?", "Family psychiatric history?"],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "history",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["Communication", "Financial stress", "Pressure to get married", "Emotional abuse", "Domestic violence"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "family_stressor"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Family History"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "patientHabits",
        "subSectionTitle": "Habits",
        "subHeaderTags": ["Quantity", "Frequency"],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "habits",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["Alcohol abuse", "Smoking (tobcco, marijuana)", "Gambling", "Excessive screen time", "Binge eating"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "habits"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Habits"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "socialHistory",
        "subSectionTitle": "Social History",
        "subHeaderTags": ["Reported problems in childhood?", "Any history of trauma?", "Quality of interaction with friends/co-workers?", "Response/Methods to cope with stress?"],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "history",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Social History"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "patientGoals",
        "subSectionTitle": "Goals",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "goals",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["Reduce Anxiety", "Reduce overthinking", "Improve sleep routine", "Effecive decision making", "Building confidence levels"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "goals"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Goals"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "History",
        "subSectionKey": "historyOfPreviousTherapy",
        "subSectionTitle": "History of previous therapy",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "headers": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "presentHistory",
                "class": " ",
                "answerList": [
                    {
                        "type": "TOGGLE_SWITCH",
                        "key": "noPresentHistory",
                        "textSize": " ",
                        "header": "",
                        "configuration": {
                            "label": "History present",
                            "secondLabel": "No History present",
                            "default": true,
                            "action": "clear", // [clear | fill]
                            "linkedFieldKeys": [

                                {
                                    "key": "therapy",
                                    "value": []
                                },
                                {
                                    "key": "psychiatry",
                                    "value": []
                                }
                            ]
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "History of previous therapy",
                                        "field": "Toggle",
                                    }
                                }
                            ]
                        }
                    },
                ]
            },
            {
                "questionTitle": "",
                "key": "therapy",
                "class": " ",
                "answerList": [
                    {
                        "type": "TEMPLATED_LIST",
                        "listHeader": "Visited a therapist before?",
                        "templatedListConfiguration": {
                            "preventRowAddition": false,
                            "hideRemoveBtn": false,
                            "autoAddNewRow": false
                        },
                        "dependentQues": {
                            "questionKey": "presentHistory",
                            "answerKey": "noPresentHistory"
                        },
                        "fields": [
                            {
                                "type": "TEXT_FIELD",
                                "key": "when",
                                "placeholder": "When (MM/YYYY)",
                                "textSize": "small"
                            },
                            {
                                "type": "TEXT_FIELD",
                                "key": "noOfSessions",
                                "placeholder": "No. of sessions",
                                "textSize": "small"
                            },
                            {
                                "type": "TEXT_FIELD",
                                "key": "reason",
                                "placeholder": "Reason",
                                "textSize": "medium"
                            },
                        ],
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Visited a therapist before?"
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            {
                "questionTitle": "",
                "key": "psychiatry",
                "class": " ",
                "answerList": [
                    {
                        "type": "TEMPLATED_LIST",
                        "listHeader": "Visited a psychiatrist before?",
                        "templatedListConfiguration": {
                            "preventRowAddition": false,
                            "hideRemoveBtn": false,
                            "autoAddNewRow": false
                        },
                        "dependentQues": {
                            "questionKey": "presentHistory",
                            "answerKey": "noPresentHistory"
                        },
                        "fields": [
                            {
                                "type": "TEXT_FIELD",
                                "key": "when",
                                "placeholder": "When (MM/YYYY)",
                                "textSize": "small"
                            },
                            {
                                "type": "TEXT_FIELD",
                                "key": "noOfSessions",
                                "placeholder": "No. of sessions",
                                "textSize": "small"
                            },
                            {
                                "type": "TEXT_FIELD",
                                "key": "reason",
                                "placeholder": "Reason",
                                "textSize": "medium"
                            },
                        ],
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Intake and History",
                                        "widget": "Visited a psychiatrist before?"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
]